import type { MeResponse } from '@albuelis-accounting/shared';
import { api } from './http';

/** `GET /me` — current user, environment and feature flags for the shell. */
export function getMe(signal?: AbortSignal): Promise<MeResponse> {
  return api.get<MeResponse>('/me', signal ? { signal } : {});
}
